<template>
    <v-tabs>
        <v-tab>Генератор сообщений</v-tab>
        <v-tab>Дерево</v-tab>
        <v-tab>Маркет</v-tab>
        <v-tab-item><tool-wa-message-constructor></tool-wa-message-constructor></v-tab-item>
        <v-tab-item><tool-client-tree></tool-client-tree></v-tab-item>
        <v-tab-item><tool-market></tool-market></v-tab-item>
    </v-tabs>
</template>

<script>
import ToolMarket from '../../components/bot/tool/ToolMarket'
import ToolClientTree from '../../components/bot/tool/ToolClientTree'
import ToolWaMessageConstructor from '../../components/bot/tool/ToolWaMessageConstructor';

export default {
    name: 'Tool',
    components: {
        ToolMarket,
        ToolClientTree,
        ToolWaMessageConstructor
    }
}
</script>

<style scoped>

</style>
